import produce from 'immer';
import initialState from '../initialState/htmlOutput';
import * as htmlOutputActionTypes from '../../constants/actionTypes/htmlOutput';

const htmlOutput = (state = initialState, action) => produce(state, (draftState) => {
    switch (action.type) {
        case htmlOutputActionTypes.UPDATE_HTML_BODY_LOADED_STATUS:
            draftState.loaded = action.payload;
            break;
        case htmlOutputActionTypes.UPDATE_HTML_BODY:
            draftState.body = action.payload.html;
            draftState.bodyWithEmbeddedCustomFonts =
                action.payload.useEmbeddedCustomFonts ? action.payload.htmlWithEmbeddedCustomFonts : action.payload.html;
            draftState.loaded = true;
            draftState.size = action.payload.html ? action.payload.html.length : 0;
            draftState.useEmbeddedCustomFonts = action.payload.useEmbeddedCustomFonts ? action.payload.useEmbeddedCustomFonts : false;
            break;
        default:
    }
});

export default htmlOutput;
